import * as CL from '@design-system/component-library';

import './LoadingOverlayCoCo.scss';

export interface LoadingOverlayProps {
  label: string;
}

export const LoadingOverlayCoCo = ({ label }: LoadingOverlayProps) => (
  <div className="of-loading-overlay" role="status" aria-live="polite">
    <div className="of-loading-overlay__backdrop" />
    <div className="of-loading-overlay__spinner">
      <CL.Loader i18n_loader_ariaText={label} i18n_loader_description={label} />
    </div>
  </div>
);
